import { Stack } from '@chakra-ui/react';
import {
  RiAncientGateLine,
  RiBookmark2Line,
  RiBookmarkLine,
  RiContactsLine,
  RiDashboardLine,
  RiEqualizerLine,
  RiFileForbidLine,
  RiFlagLine,
  RiGitRepositoryPrivateLine,
  RiHotelLine,
  RiInputMethodLine,
  RiMoneyDollarCircleLine,
  RiShieldUserLine,
  RiShoppingBasket2Line,
} from 'react-icons/ri';
import { features } from '../../config/features';
import { useAuth } from '../../hooks/auth';
import { NavLink } from './NavLink';
import { NavSection } from './NavSection';

export const SidebarNav = (): JSX.Element => {
  const { assignment: authenticatedAssignment } = useAuth();
  const isMaster =
    authenticatedAssignment?.featureGroup.key.includes('MASTER') ?? false;

  return (
    <Stack spacing="12" align="flex-start" minWidth="170px">
      <NavSection title="Geral">
        <NavLink icon={RiDashboardLine} to="/dashboard">
          Dashboard
        </NavLink>

        {authenticatedAssignment?.featureGroup.features.some((feature) =>
          ['ACTIVITY_FULL_ACCESS', 'ACTIVITY_READ_ACCESS'].includes(
            feature.key,
          ),
        ) && (
          <NavLink icon={RiInputMethodLine} to="/activities">
            Atividades
          </NavLink>
        )}

        {authenticatedAssignment?.featureGroup.features.some((feature) =>
          [
            'BOOKING_FULL_ACCESS',
            'BOOKING_READ_ACCESS',
            'BOOKING_SELLER_READ_ACCESS',
          ].includes(feature.key),
        ) && (
          <NavLink icon={RiBookmarkLine} to="/bookings">
            Reservas
          </NavLink>
        )}

        {features.productsServicesEnabled &&
          authenticatedAssignment?.featureGroup.features.some((feature) =>
            ['PRODUCT_FULL_ACCESS', 'PRODUCT_READ_ACCESS'].includes(
              feature.key,
            ),
          ) && (
            <NavLink icon={RiShoppingBasket2Line} to="/services">
              Produtos | Serviços
            </NavLink>
          )}

        {authenticatedAssignment?.featureGroup.features.some((feature) =>
          [
            'BOOKING_FULL_ACCESS',
            'BOOKING_NO_SHOW_HISTORY_READ_ACCESS',
          ].includes(feature.key),
        ) && (
          <NavLink icon={RiBookmark2Line} to="/booking-no-shows">
            No shows
          </NavLink>
        )}

        {authenticatedAssignment?.featureGroup.features.some((feature) =>
          [
            'BOOKING_CANCELLATION_HISTORY_FULL_ACCESS',
            'BOOKING_CANCELLATION_HISTORY_READ_ACCESS',
          ].includes(feature.key),
        ) && (
          <NavLink icon={RiFileForbidLine} to="/booking-cancellations">
            Cancelamentos
          </NavLink>
        )}

        {/* {authenticatedUser.featureGroup.features.some((feature) =>
          ['BOOKING_QUEUE_FULL_ACCESS', 'BOOKING_QUEUE_READ_ACCESS'].includes(
            feature.key,
          ),
        ) && (
          <NavLink icon={RiListCheck2} to="/booking-queues">
            Filas de espera
          </NavLink>
        )} */}
      </NavSection>

      {authenticatedAssignment?.featureGroup.features.some((feature) =>
        [
          'USER_FULL_ACCESS',
          'USER_READ_ACCESS',
          'EMPLOYEE_FULL_ACCESS',
          'LODGER_FULL_ACCESS',
          'LODGER_READ_ACCESS',
          'SPOT_FULL_ACCESS',
          'SPOT_READ_ACCESS',
          'VENTURE_FULL_ACCESS',
          'VENTURE_READ_ACCESS',
        ].includes(feature.key),
      ) && (
        <>
          <NavSection title="Administrativo">
            {authenticatedAssignment?.featureGroup.features.some((feature) =>
              [
                'USER_FULL_ACCESS',
                'USER_READ_ACCESS',
                'EMPLOYEE_FULL_ACCESS',
              ].includes(feature.key),
            ) && (
              <>
                <NavLink icon={RiContactsLine} to="/users">
                  Funcionários
                </NavLink>
              </>
            )}

            {authenticatedAssignment?.featureGroup.features.some((feature) =>
              ['USER_FULL_ACCESS', 'USER_READ_ACCESS'].includes(feature.key),
            ) && (
              <>
                <NavLink icon={RiShieldUserLine} to="/members">
                  Membros
                </NavLink>
              </>
            )}

            {authenticatedAssignment?.featureGroup.features.some((feature) =>
              ['LODGER_FULL_ACCESS', 'LODGER_READ_ACCESS'].includes(
                feature.key,
              ),
            ) && (
              <NavLink icon={RiHotelLine} to="/lodgers">
                Hóspedes
              </NavLink>
            )}

            {authenticatedAssignment?.featureGroup.features.some((feature) =>
              ['SPOT_FULL_ACCESS', 'SPOT_READ_ACCESS'].includes(feature.key),
            ) && (
              <NavLink icon={RiFlagLine} to="/spots">
                Locais
              </NavLink>
            )}

            {authenticatedAssignment?.featureGroup.features.some((feature) =>
              ['VENTURE_FULL_ACCESS', 'VENTURE_READ_ACCESS'].includes(
                feature.key,
              ),
            ) && (
              <NavLink icon={RiAncientGateLine} to="/ventures">
                Empreendimentos
              </NavLink>
            )}

            {authenticatedAssignment?.featureGroup.features.some((feature) =>
              [
                'BOOKING_PAYMENT_REPORTS_FULL_ACCESS',
                'BOOKING_PAYMENT_REPORTS_READ_ACCESS',
              ].includes(feature.key),
            ) && (
              <NavLink icon={RiMoneyDollarCircleLine} to="/booking-reports">
                Relatórios vendas
              </NavLink>
            )}
          </NavSection>
        </>
      )}

      {(isMaster ||
        authenticatedAssignment?.featureGroup.features.some((feature) =>
          [
            'FEATURE_GROUP_FULL_ACCESS',
            'FEATURE_GROUP_MANAGEMENT',
            'FEATURE_FULL_ACCESS',
            'FEATURE_MANAGEMENT',
          ].includes(feature.key),
        )) && (
        <NavSection title="Configurações">
          {(isMaster ||
            authenticatedAssignment?.featureGroup.features.some((feature) =>
              [
                'FEATURE_GROUP_FULL_ACCESS',
                'FEATURE_GROUP_MANAGEMENT',
              ].includes(feature.key),
            )) && (
            <NavLink icon={RiEqualizerLine} to="/feature-groups">
              Grupos de permissões
            </NavLink>
          )}

          {(isMaster ||
            authenticatedAssignment?.featureGroup.features.some((feature) =>
              ['FEATURE_FULL_ACCESS', 'FEATURE_MANAGEMENT'].includes(
                feature.key,
              ),
            )) && (
            <NavLink icon={RiGitRepositoryPrivateLine} to="/features">
              Permissões
            </NavLink>
          )}
        </NavSection>
      )}
    </Stack>
  );
};
